export default "__VITE_ASSET__Cmgk6QCG__"